import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pure from 'recompose/pure';
import FalseIcon from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

export const BooleanField = ({
  className, source, record = {}, color, ...rest
}) => {
  if (get(record, source) === true) {
    return (
      <Typography
        component="span"
        body1="body1"
        className={className}
        style={{
          textAlign: 'center',
          fontFamily: 'Open Sans',
          fontSize: 12,
          fontWeight: 700,
          color
        }}
        {...sanitizeRestProps(rest)}
      >
        Да
      </Typography>
    );
  }
  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
      style={{ textAlign: 'center' }}
      {...sanitizeRestProps(rest)}
    >
      <FalseIcon style={{ width: '10px', height: '10px', fill: '#b0b0b0' }} />
    </Typography>
  );
};

BooleanField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

const PureBooleanField = pure(BooleanField);

PureBooleanField.defaultProps = {
  addLabel: true,
};

export default PureBooleanField;



// WEBPACK FOOTER //
// ./src/components/ejected/BooleanField.js